import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {AuthenticationManager, ProgressIndicatorService} from '../@shared';
import {StatePersistenceService} from "../service/state.persistence.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    blocked: boolean;

    constructor(public authenticationManager: AuthenticationManager,
                public state: StatePersistenceService,
                private progressIndicatorService: ProgressIndicatorService,
                @Inject(DOCUMENT) public document: Document) {
        this.blocked = false;
        progressIndicatorService.event$.subscribe(item => this.onProgressNotificationEvent(item));
    }

    ngOnInit(): void {
    }

    onProgressNotificationEvent(item: boolean): void {
        this.blocked = item;
    }
}
